import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantSlackAccessInputClass;
function GrantSlackAccessInput() {
  if (GrantSlackAccessInputClass === VOID) {
    class $ {
      constructor(code, state) {
        this.n6n_1 = code;
        this.o6n_1 = state;
      }
      toString() {
        return 'GrantSlackAccessInput(code=' + this.n6n_1 + ', state=' + this.o6n_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.n6n_1);
        result = imul(result, 31) + getStringHashCode(this.o6n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessInput()))
          return false;
        if (!(this.n6n_1 === other.n6n_1))
          return false;
        if (!(this.o6n_1 === other.o6n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessInput');
    GrantSlackAccessInputClass = $;
  }
  return GrantSlackAccessInputClass;
}
//region block: exports
export {
  GrantSlackAccessInput as GrantSlackAccessInput3j0s7of1xul8d,
};
//endregion

//# sourceMappingURL=GrantSlackAccessInput.mjs.map
